export const WRITING_TYPES = [
    { id: 1, name: "Writing from scratch" },
    { id: 2, name: "Editing" },
    { id: 3, name: "Remove AI Content (Humanize)" },
    { id: 4, name: "Rewriting" },
]

export const TYPE_OF_PAPERS = [
    { id: 1, name: "Essay (Any type)" },
    { id: 2, name: "Discussion Post" },
    { id: 3, name: "Research Paper" },
    { id: 4, name: "Term Paper" },
    { id: 5, name: "Thesis" },
    { id: 6, name: "Dissertation" },
    { id: 7, name: "Reflection Paper" },
    { id: 8, name: "Argumentative Essay" },
    { id: 9, name: "Persuasive Essay" },
    { id: 10, name: "Narrative Essay" },
    { id: 11, name: "Literature Review" },
    { id: 12, name: "Systematic Review" },
    { id: 13, name: "Case Study" },
    { id: 14, name: "Annotated Bibliography" },
    { id: 15, name: "Lab Report" },
    { id: 16, name: "Article Critique" },
    { id: 17, name: "Policy Paper" },
    { id: 18, name: "Business Plan" },
    { id: 19, name: "Literary Analysis" },
    { id: 20, name: "Expository Essay" },
    { id: 21, name: "Descriotive Essay" },
    { id: 22, name: "Question-Answer" },
    { id: 23, name: "Powerpoint" },
    { id: 24, name: "Infographic" },
]

export const ACADEMIC_LEVELS = [
    { id: 1, name: "College" },
    { id: 2, name: "University" },
    { id: 3, name: "Masters" },
    { id: 4, name: "Doctorate" },
]

export const TYPE_OF_ENGLISH = [
    { id: 1, name: "US English" },
    { id: 2, name: "UK English", extraAdder: "(+10%)" },
]

export const DEADLINES = [
    { id: 1, name: "21 days" },
    { id: 2, name: "14 days" },
    { id: 3, name: "10 days" },
    { id: 4, name: "06 days" },
    { id: 5, name: "04 days" },
    { id: 6, name: "02 days" },
    { id: 7, name: "24 hours" },
    { id: 8, name: "12 hours" },
    { id: 9, name: "06 hours" },
    { id: 10, name: "03 hours" },
]


export const SPACINGS = [
    { id: 1, name: "Double Spacing" },
    { id: 2, name: "Single Spacing" },
]

export const REERENCE_STYLES = [
    { id: 1, name: "MLA" },
    { id: 2, name: "APA" },
    { id: 3, name: "Chicago" },
    { id: 4, name: "Harvard" },
    { id: 5, name: "Turabian" },
    { id: 6, name: "Writer's Choice" },
    { id: 7, name: "Not Applicable" },
]

export const SUBJECTS = {
    "Accounting":[
        "Accounting",
        "Cost Accounting",
        "Financial accounting",
        "Managerial accounting",
    ],
    "Arts and Humanities":[
        "Arts and Humanities",
        "Communications",
        "Marketing",
        "English",
        "Literature",
    ],
    "Biology":[
        "Anatomy",
        "Biochemistry",
        "Biology",
        "Cell biology",
        "Ecology",
        "Genetics",
        "Microbiology",
        "Nutrition",
        "Pharmacology",
        "Physiology"
    ],
    "Biostatistics": "Biostatistics",
    "Business" : [
        "Business",
        "Business Law"
    ],
    "Chemistry": [
        "Chemistry",
        "Inorganic chemistry",
        "Organic chemistry",
    ],
    "Computer Science": "Computer Science",
    "Economics": [
        "Econometrics",
        "Economics",
        "Macroeconomics",
        "Microeconomics",
    ],
    "Education" : "Education",
    "Engineering": "Engineering",
    "Finance": "Finance",
    "Health Sciences and Nursing" : "Health Sciences and Nursing",
    "History":[
        "History",
        "US history",
    ],
    "Management":[
        "Human Resource Management",
        "Management",
        "Operations Management",
        "Project Management",
        "Supply Chain Management",
    ],
    "Mathematics": "Mathematics",
    "Other Subject": "Other Subject",
    "Physics": "Physics",
    "Religion": "Religion",
    "Social Sciences": [
        "Social Sciences",
        "Law",
        "Psychology",
        "Social psychology",
        "Sociology",
    ]
};

let arr = [];

for(const [key, value] of Object.entries(SUBJECTS)){
    if(Array.isArray(value)){
        arr = arr.concat(value)
    }else{
        arr.push(value)
    }
}

arr.sort()

// exports.subjects = subjects;

export const SUBJECTS_ARRAY = new Array(...new Set(arr)).map((it, index) => {return {id: (index + 1), name: it}});